function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Button, Alert, Select, Tag, InputNumber, Divider, notification, List, Space, Modal, Drawer, Empty, Radio } from "antd";
import { Container, Row, Col } from 'react-bootstrap';
import Common from "../includes/Common";
import AddItemCategory from "./AddItemCategory";
import { BoxFill, CheckCircleFill, Plus, Dash, XOctagonFill, Cart4, HouseFill, XCircleFill } from "react-bootstrap-icons";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import Receipt from "../Receipt";
import AddressInput from "./AddressInput";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var OrderFromCustomer = function OrderFromCustomer(_ref) {
  var _ref$handler = _ref.handler,
    handler = _ref$handler === void 0 ? function () {} : _ref$handler,
    _ref$customer = _ref.customer,
    customer = _ref$customer === void 0 ? null : _ref$customer;
  var ref = useRef();
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    sellableCategories = _useState8[0],
    setSellableCategories = _useState8[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState9 = useState(""),
    _useState0 = _slicedToArray(_useState9, 2),
    loadError = _useState0[0],
    setLoadError = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isDataChanged = _useState10[0],
    setIsDataChanged = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    itemOptions = _useState12[0],
    setItemOptions = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    items = _useState14[0],
    setItems = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedItems = _useState16[0],
    setSelectedItems = _useState16[1];
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    totalCash = _useState18[0],
    setTotalCash = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    paymentMethods = _useState20[0],
    setPaymentMethods = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    selectedPaymentMethodId = _useState22[0],
    setSelectedPaymentMethodId = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    providers = _useState24[0],
    setProviders = _useState24[1];
  var _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    selectedCategoryId = _useState26[0],
    setSelectedCategoryId = _useState26[1];
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    selectedProviderId = _useState28[0],
    setSelectedProviderId = _useState28[1];
  var _useState29 = useState(null),
    _useState30 = _slicedToArray(_useState29, 2),
    customerMobile = _useState30[0],
    setCustomerMobile = _useState30[1];
  var _useState31 = useState(null),
    _useState32 = _slicedToArray(_useState31, 2),
    paymentMethodId = _useState32[0],
    setPaymentMethodId = _useState32[1];
  var _useState33 = useState(null),
    _useState34 = _slicedToArray(_useState33, 2),
    providerId = _useState34[0],
    setProviderId = _useState34[1];
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    showReceipt = _useState36[0],
    setShowReceipt = _useState36[1];
  var _useState37 = useState(null),
    _useState38 = _slicedToArray(_useState37, 2),
    lastCreatedOrder = _useState38[0],
    setLastCreatedOrder = _useState38[1];
  var _useState39 = useState([]),
    _useState40 = _slicedToArray(_useState39, 2),
    locationOptions = _useState40[0],
    setLocationOptions = _useState40[1];
  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    loading = _useState42[0],
    setLoading = _useState42[1];
  var _useState43 = useState({
      address: "",
      latitude: null,
      longitude: null
    }),
    _useState44 = _slicedToArray(_useState43, 2),
    location = _useState44[0],
    setLocation = _useState44[1];
  var handleLocationSelect = function handleLocationSelect(data) {
    setLocation({
      address: data.address,
      latitude: data.latitude,
      longitude: data.longitude
    });
  };
  var onFinish = function onFinish(values) {
    setFormError('');
    setFormSuccess('');
    var item = items.find(function (i) {
      return i.value === values.sellable_id;
    });
    if (!item) return;
    var price = values.order_type === 0 ? item.recharge_price : item.consignation_price;
    setSelectedItems(function (prev) {
      var existing = prev.find(function (i) {
        return i.value === values.sellable_id;
      });
      if (existing) {
        return prev.map(function (i) {
          return i.value === values.sellable_id ? _objectSpread(_objectSpread({}, i), {}, {
            quantity: i.quantity + values.quantity,
            price: price
          }) : i;
        });
      }
      return [].concat(_toConsumableArray(prev), [{
        value: item.id,
        id: item.id,
        label: item.label,
        quantity: values.quantity,
        price: price
      }]);
    });
    setTotalCash(function (prev) {
      return prev + price * values.quantity;
    });
    setProviderId(values.provider_id);
  };
  var handleMobileChange = function handleMobileChange(v) {
    setCustomerMobile(v.target.value);
  };
  var createInvoice = function createInvoice() {
    setIsFormLoading(true);
    var itemsArg = new Array();
    var itemsQuantityArg = new Array();
    var itemsLabelArg = new Array();
    var itemsPriceArg = new Array();
    selectedItems.forEach(function (i) {
      itemsArg.push(i.id);
      itemsQuantityArg.push(i.quantity);
      itemsLabelArg.push(i.label);
      itemsPriceArg.push(i.price);
    });
    axios.post(Common.baseApiUrl + "paycustomerorder", {
      provider_id: providerId,
      customer_mobile: customerMobile,
      payment_method_id: selectedPaymentMethodId,
      items: itemsArg,
      quantities: itemsQuantityArg,
      labels: itemsLabelArg,
      prices: itemsPriceArg,
      total_amount: totalCash
    }).then(function (response) {
      if (response.data.status == 201) {
        window.location.href = response.data.handshake.payment_url;
      } else {
        notification.error({
          message: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var handlePlus = function handlePlus(item) {
    setSelectedItems(function (prev) {
      var existing = prev.find(function (i) {
        return i.id === item.id;
      });
      if (existing) {
        return prev.map(function (i) {
          return i.id === item.id ? _objectSpread(_objectSpread({}, i), {}, {
            quantity: i.quantity + 1
          }) : i;
        });
      }
      return [].concat(_toConsumableArray(prev), [{
        id: item.id,
        key: item.id,
        label: item.label,
        quantity: 1,
        price: item.price
      }]);
    });
    setTotalCash(function (prev) {
      return prev + item.price;
    });
  };
  var handleMinus = function handleMinus(item) {
    setSelectedItems(function (prev) {
      var existing = prev.find(function (i) {
        return i.id === item.id;
      });
      if (!existing) return prev;
      if (existing.quantity <= 1) {
        return prev.filter(function (i) {
          return i.id === item.id;
        });
      }
      return prev.map(function (i) {
        return i.id === item.id ? _objectSpread(_objectSpread({}, i), {}, {
          quantity: i.quantity - 1
        }) : i;
      });
    });
    setTotalCash(function (prev) {
      return Math.max(0, prev - item.price);
    });
  };
  var handleClearItem = function handleClearItem(item) {
    var existing = selectedItems.find(function (i) {
      return i.id === item.id;
    });
    if (!existing) return;
    setSelectedItems(function (prev) {
      return prev.filter(function (i) {
        return i.id !== item.id;
      });
    });
    setTotalCash(function (prev) {
      return prev - existing.price * existing.quantity;
    });
  };
  useEffect(function () {
    setIsDataChanged(false);
    form.setFieldsValue({
      quantity: 1,
      order_type: 0
    });
    axios.all([axios.get(Common.baseApiUrl + 'getsellablecategories/0'), axios.get(Common.baseApiUrl + 'getsellables/0'), axios.get("".concat(Common.baseApiUrl, "getpaymentmethods/0")), axios.get("".concat(Common.baseApiUrl, "getproviders/0"))]).then(function (response) {
      if (response[0].data.status == 200) {
        setSellableCategories([]);
        response[0].data.categories.forEach(function (s) {
          setSellableCategories(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: s.id,
              label: s.label
            }]);
          });
        });
        if (response[0].data.categories.length > 0) {
          form.setFieldsValue({
            sellable_category_id: response[0].data.categories[0].id
          });
        }
      } else {
        setLoadError(response[0].data.message);
      }
      if (response[3].data.status == 200) {
        setProviders([]);
        response[3].data.providers.forEach(function (p) {
          setProviders(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: p.id,
              label: p.label
            }]);
          });
        });
        if (response[3].data.providers.length > 0) form.setFieldsValue({
          provider_id: response[3].data.providers[0].id
        });
      }
      if (response[1].data.status == 200) {
        var _providerId = response[3].data.providers.length > 0 ? response[3].data.providers[0].id : null;
        var categoryId = response[0].data.categories.length > 0 ? response[0].data.categories[0].id : null;
        var options = response[1].data.sellables.map(function (i) {
          return {
            value: i.id,
            label: i.label,
            key: i.id,
            id: i.id,
            provider_id: i.provider_id,
            sellable_category_id: i.sellable_category_id
          };
        });
        var sellables = response[1].data.sellables.map(function (i) {
          return {
            value: i.id,
            key: i.id,
            id: i.id,
            label: i.label,
            recharge_price: i.recharge_price,
            consignation_price: i.consignation_price,
            price: i.price,
            provider_id: i.provider_id,
            sellable_category_id: i.sellable_category_id
          };
        });
        var filteredOptions = options.filter(function (o) {
          return (!_providerId || o.provider_id === _providerId) && (!categoryId || o.sellable_category_id === categoryId);
        });
        setItemOptions(filteredOptions);
        if (filteredOptions.length > 0) form.setFieldsValue({
          sellable_id: filteredOptions[0].value
        });
        setItems(sellables);
      }
      if (response[2].data.status == 200) {
        setPaymentMethods([]);
        response[2].data.methods.forEach(function (p) {
          setPaymentMethods(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: p.id,
              label: p.label
            }]);
          });
        });
        if (response[2].data.methods.length > 0) form.setFieldsValue({
          payment_method_id: response[2].data.methods[0].id
        });
      }
    })["catch"](function (error) {
      setLoadError('Une erreur est survenue');
    })["finally"](function () {});
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      size: "large",
      form: form,
      onFinish: onFinish,
      children: [formError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: formError,
          showIcon: true
        })
      }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: formSuccess,
          showIcon: true
        })
      }), loadError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: loadError,
          showIcon: true
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "provider_id",
            children: /*#__PURE__*/_jsx(Select, _defineProperty(_defineProperty(_defineProperty({
              placeholder: "Choisir un fournisseur",
              onChange: function onChange(v) {
                setSelectedProviderId(v);
                setItemOptions(items.filter(function (o) {
                  return o.provider_id === v && (!selectedCategoryId || o.sellable_category_id === selectedCategoryId);
                }));
              }
            }, "placeholder", "Fournisseur"), "options", providers), "rules", [{
              required: true,
              message: 'Ce champs est obligatoire'
            }]))
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "sellable_category_id",
            children: /*#__PURE__*/_jsx(Select, {
              onChange: function onChange(v) {
                placeholder = "Catégorie";
                setSelectedCategoryId(v);
                setItemOptions(items.filter(function (o) {
                  return (!selectedProviderId || o.provider_id === selectedProviderId) && o.sellable_category_id === v;
                }));
              },
              placeholder: "Choisir une cat\xE9gorie",
              options: sellableCategories,
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }]
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 8,
          sm: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "sellable_id",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              placeholder: "Choisir une article",
              options: itemOptions
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "quantity",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              placeholder: "Qte"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "order_type",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Radio.Group, {
          block: true,
          size: "large",
          options: [{
            label: "RECHARGE",
            value: 0
          }, {
            label: "CONSIGNATION",
            value: 1
          }],
          defaultValue: 0,
          optionType: "button"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          icon: /*#__PURE__*/_jsx(Plus, {}),
          size: "small",
          htmlType: "submit",
          disabled: sellableCategories.length == 0,
          loading: isFormLoading,
          type: "link",
          children: /*#__PURE__*/_jsx("b", {
            children: " AJOUTER"
          })
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        padding: "6px"
      },
      children: [/*#__PURE__*/_jsx(List, {
        dataSource: selectedItems,
        size: "small",
        itemLayout: "vertical",
        locale: {
          emptyText: /*#__PURE__*/_jsx(Empty, {
            image: /*#__PURE__*/_jsx(Cart4, {
              size: 46
            }),
            description: "Votre panier est vide"
          })
        },
        renderItem: function renderItem(item, index) {
          return /*#__PURE__*/_jsx(List.Item, {
            actions: [/*#__PURE__*/_jsx(Button, {
              size: "small",
              type: "link",
              onClick: function onClick() {
                handlePlus(item);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(Plus, {
                  size: 20
                })
              })
            }), /*#__PURE__*/_jsx(Button, {
              size: "small",
              type: "link",
              disabled: item.quantity <= 1,
              onClick: function onClick() {
                handleMinus(item);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(Dash, {
                  size: 20
                })
              })
            }), /*#__PURE__*/_jsx(Button, {
              size: "small",
              type: "link",
              onClick: function onClick() {
                handleClearItem(item);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(XCircleFill, {
                  size: 20
                })
              })
            })],
            children: /*#__PURE__*/_jsx(List.Item.Meta, {
              avatar: /*#__PURE__*/_jsx(BoxFill, {
                size: 14
              }),
              title: /*#__PURE__*/_jsxs("span", {
                style: {
                  fontSize: "14px"
                },
                children: [item.label, " | Qte: ", item.quantity, ", P.U: ", item.price.toLocaleString("Fr")]
              })
            })
          });
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h5", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "Total \xE0 payer: "
        }), totalCash.toLocaleString("Fr")]
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(AddressInput, {
      value: location.address,
      onChange: function onChange(value) {
        return setLocation(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            address: value
          });
        });
      },
      onLocationSelect: handleLocationSelect
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), ContextHolder, /*#__PURE__*/_jsx(Button, {
      size: "large",
      type: "default",
      disabled: selectedItems.length == 0,
      icon: /*#__PURE__*/_jsx(CheckCircleFill, {}),
      loading: isFormLoading,
      onClick: function onClick() {
        createInvoice();
      },
      children: isFormLoading ? /*#__PURE__*/_jsx("b", {
        children: "TRAITEMENT EN COURS"
      }) : /*#__PURE__*/_jsx("b", {
        children: " PAYER MAINTENANT"
      })
    })]
  });
};
export default OrderFromCustomer;